import { useContext } from 'react';
import { AdvertBottomSheetContext, AdvertBottomSheetContextType } from '#advertBottomSheet/contexts';

const useAdvertBottomSheetContext = () => useContext<AdvertBottomSheetContextType>(AdvertBottomSheetContext);

export { useAdvertBottomSheetContext };
